<div class="unsdg-icon" [app-tooltip]="{ position: ['top'], message: UNSDGTitle }">
  <img [style.width.px]="size" [style.height.px]="size" src="{{ UNSDGIconURL }}" />
</div>
